<template>
  <div v-if="renderData && renderData.length && renderData.length > 1" class="topsellingcard" :class="isFilterLanding ? 'filter-landing-topselling-card': null">
    <div class="topsellingcard__title-cont">
      <div v-if="callerComp==='summerCollection'" class='heading_container'>
        <img :data-src="isDesktop ? baseImgServerUrl + 'tile-side-design.png' : baseImgServerUrl + 'tile-side-design-mobile.png'" alt="Zig Zag lines"/>
        <h3 v-if="renderName" class='summer-collection-heading'>{{renderName}}</h3>
        <img :data-src="isDesktop ? baseImgServerUrl + 'tile-side-design.png' : baseImgServerUrl + 'tile-side-design-mobile.png'" alt="Zig Zag lines"/>
      </div>
      <div v-else-if="isFilterLanding" class='title-container'>
        <div v-if="renderName" class="category-title-container">
          <div class='mobile-lines-container'>
            <div v-for="(e, i) in deviceWidth" :key="i" class='rotate-line'>|</div>
          </div>
          <h3 class="filter-landing-title">{{renderName}}</h3>
        </div>
      </div>
      <h3 v-else-if="renderName" :class="!isDesktop ? 'text-left pl-4' : ''" class="title">{{renderName}}</h3>
      <p v-if="getDescription" class="descrition">{{getDescription}}</p>
    </div>
    <div class="headtop prelative top-banner">
      <carousel
        ref="my-carousel" :navigationEnabled="isDesktop"
        :paginationEnabled="!isDesktop" navigationNextLabel=" " navigationPrevLabel=" "
        :loop="true" :autoplay="shouldAutoPlay" :paginationPadding="1" :autoplayTimeout="6000"
        :speed="500" class="bannerview mobileBannerView"  :paginationColor="isFilterLanding ? '#979a9f' : ''"
        :perPageCustom="[[480, 2], [768, 4], [1200, 4]]" :perPage="2" :paginationSize="6"
      >
        <slide v-for="(prm, index) in productsListing && productsListing.slice(0, productsListing.length-1)" :key="index" class="col-md-3 col-6">
          <div v-if="callerComp==='new arrival' || isRecommendedTopSelling">
            <TopSellingImgBlock :parry="prm.imageUrl && prm.imageUrl[0] ? baseImgPath + path + prm.imageUrl[0] : ''" :imageH="400" :imageW="300"
              :index="index"
              :urlKey="prm.productUrl" :productTitle="prm.title"
              :productCat="prm.category && prm.category[0]" :productPrice="parseInt(prm.price)"
              :pclass="'itemsmall'" :souledout="false" :spprice="parseInt(prm.spl_price)"
              :exclusivePrice="prm.exclusive_price" :isExclusive="isExclusive"
              :renderName="renderName"
              :callerComp="callerComp"
              :genderType="prm.gender ? 2 : 1" :cardStyle="isFilterLanding && !isDesktop ? {border: '1px solid #e8e8e8'} : ''">
            </TopSellingImgBlock>
          </div>
          <div v-else>
            <TopSellingImgBlock :parry="prm.image" :imageH="400" :imageW="300"
              :index="index"
              :urlKey="prm.product_slug" :productTitle="prm.product_name"
              :productCat="prm.product_type" :productPrice="parseInt(prm.original_price)"
              :product="prm"
              :isWidgetProduct="isWidgetProduct"
              :pclass="'itemsmall'" :souledout="false" :spprice="parseInt(prm.spl_price)"
              :exclusivePrice="prm.exclusive_price" :isExclusive="isExclusive"
              :renderName="renderName"
              :callerComp="callerComp"
              :genderType="prm.gender ? 2 : 1" :cardStyle="isFilterLanding && !isDesktop ? {border: '1px solid #e8e8e8'} : ''"
              :widgetType="widgetType">
            </TopSellingImgBlock>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
var $ = require('jquery')
window.jQuery = $
import {Carousel, Slide} from 'vue-carousel'
import TopSellingImgBlock from './TopSellingImgBlock.vue'
import {mapGetters} from 'vuex'
import {appMixins} from '../../assets/js/appMixins'
export default {
  mixins: [appMixins],
  data () {
    return {
      baseImgPath: process.env.IMG_BASE_URL,
      path: process.env.PRODUCT_IMG,
      baseImgServerUrl: process.env.STATIC_IMG_SERVER2 + 'icons/'
    }
  },
  props: ['renderName', 'renderData', 'description', 'hasDescription', 'callerComp', 'isFilterLanding', 'deviceWidth', 'widgetType', 'isWidgetProduct'],
  components: {
    Carousel,
    Slide,
    TopSellingImgBlock
  },
  computed: {
    ...mapGetters(['isExclusive', 'tatvicProductImpression', 'bannerPlcaeHolderData', 'recommTopSellingData', 'authStatus', 'moengageImpressionData']),
    getDescription: function () {
      if (this.renderData && this.renderData.length > 1) {
        if (this.hasDescription) {
          return this.description
        }
        return this.renderData[this.renderData.length - 1][3]
      }
    },
    shouldAutoPlay () {
      if (this.enableHorizontalScrollTop10PickOfTheWeek && this.renderName === 'TOP 10 PICKS OF THE WEEK') {
        return true
      } else {
        return false
      }
    },
    enableHorizontalScrollTop10PickOfTheWeek: function () {
      return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.product_type.toLowerCase() === 'AUTO_PLAY_TOP_10_PICKS'.toLowerCase())
    },
    productsListing () {
      if (this.isRecommendedTopSelling) {
        return [...this.recommTopSellingData, []]
      }
      return this.renderData
    },
    bannerPlaceHolderForRecommTopSelling: function () {
      return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.product_type.toLowerCase() === 'HIDE_RECOMM_TOP_SELLING_WEB'.toLowerCase())
    },
    isRecommendedTopSelling () {
      return !this.bannerPlaceHolderForRecommTopSelling && this.callerComp === 'homePage' && this.recommTopSellingData && this.recommTopSellingData.length
    }
  },
  methods: {
    getRecommTopSellingData () {
      if (!this.bannerPlaceHolderForRecommTopSelling && this.callerComp === 'homePage') {
        this.$store.dispatch('GET_RECOMMENDED_TOP_SELLING_DATA')
      }
    }
  },
  mounted () {
    this.getRecommTopSellingData()
  },
  beforeDestroy () {
    if (this.tatvicProductImpression && this.tatvicProductImpression.data.length) {
      // this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'view_item_list',
      //   payload: {
      //     ecommerce: {
      //       'items': [
      //         ...this.tatvicProductImpression.data
      //       ]
      //     },
      //     user_id: (this.user && this.user.user_id) || 'NA'
      //   }
      // })
      this.$store.commit('EC_PLP_PROD_VIEW_RESET')
    }
    if (this.moengageImpressionData && Object.keys(this.moengageImpressionData).length) {
      this.$store.commit('MOENGAGE_EVENT', {
        eventName: 'view_product_list',
        payload: {
          ...this.moengageImpressionData
        }
      })
      this.$store.commit('MOENGAGE_PLP_PROD_VIEW_RESET')
    }
    this.$store.commit('SET_LISTING_LANDING_DATE', '')
  }
}
</script>

<style scoped>
  .topsellingcard {
    /* margin: 2rem 0; */
    min-height: 584px;
  }
  .topsellingcard .title_container{
    display:flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
  }
  .category-title-container{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
  }
  .category-title-container .rotate-line{
  transform: rotate(40deg);
  }
  .category-title-container .mobile-lines-container{
    display: flex;
    gap: 5px;
    font-size: 1.3rem;
    color: lightgray;
    font-weight: unset;
  }
  .topsellingcard .title {
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.24;
    letter-spacing: normal;
    text-align: center;
    color: #282c3f;
    text-transform: uppercase;
    margin: 0;
  }
  .topsellingcard .filter-landing-title {
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.24;
    letter-spacing: normal;
    text-align: center;
    color: #282c3f;
    text-transform: capitalize;
    margin: 0;
    font-size: 2.3rem;
    position: absolute;
    background-color: white;
    padding-left: 3.2rem;
    padding-right: 3.2rem;
  }
  .summer-collection-heading {
    font-size: 2rem;
    text-transform: capitalize;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.24;
    letter-spacing: normal;
    text-align: center;
    color: #282c3f;
    margin: 0;
  }
  .topsellingcard__title-cont {
    margin-bottom: 1.5rem;
    margin-top: 1.5rem !important;
  }
  .topsellingcard__title-cont .heading_container{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
  }
  .topsellingcard__title-cont .descrition {
    font-size: 1.6rem;
    line-height: 1.26;
    letter-spacing: normal;
    text-align: center;
    color: #525964;
    margin: 0;
  }
  .filter-landing-topselling-card{
    margin: unset;
    margin-bottom: 2.5rem;
    padding: unset !important;
    padding: 2rem 0rem;
    box-shadow: unset !important;
  }
  @media screen and (max-width: 768px) {
    .summer-collection-heading{
      font-size: 0.8rem;
    }
    .topsellingcard{
      min-height: 423px;
      height: auto;
    }
    .topsellingcard .title {
      font-size: 1.13rem;
    }
    .topsellingcard .filter-landing-title {
      font-size: .8rem;
      border-bottom: unset;
      text-transform: capitalize;
      padding-left: 1.2rem;
      padding-right: 1.2rem;
    }
    .topsellingcard {
      margin: 0;
      padding: 1rem 0rem 0.1rem 0rem;
      background-color: #ffffff;
    }
    .topsellingcard__title-cont {
      margin-bottom: .6rem;
      margin-top: 0rem !important;
    }
    .topsellingcard__title-cont .descrition {
      font-size: 1rem;
    }
    .filter-landing-topselling-card {
      margin-bottom: 1.3rem;
      padding: unset !important;
    }
    .category-title-container .mobile-lines-container{
      gap: 2px;
      font-size: 0.7rem;
      color: unset;
    }
  }
</style>



// WEBPACK FOOTER //
// TopSellingSection.vue?4e3b0f7e